import * as React from 'react';
import type { EventType } from '@sdk/schedule/types/EventType';

import type { FormattedDateString } from '../types/FormattedDateString';
import type { AddEventType } from '../types';
import type { UnassignedGroup, AvailableGroup, DynamicGroup, User } from '../types/GroupsArrayType';
import type { GroupForAddDtstart } from '../types/GroupsType';
import Flex1 from '../ui/Flex1';

import AddEventBox from './AddEventBox';

type Props = {
  isHovered?: boolean;
  hour?: boolean;
  day: FormattedDateString;
  group: UnassignedGroup | AvailableGroup | DynamicGroup | GroupForAddDtstart;
  addEvent: AddEventType;
  event?: EventType;
  user?: User;
};
const ShowPlus: React.FC<React.PropsWithChildren<Props>> = ({
  isHovered = true,
  hour = false,
  day,
  group,
  addEvent,
  event,
  user,
}) => {
  const userForEvent = (group as any).isForDtstart ? null : user || { id: 0 };
  const onClick = (): void => {
    addEvent({ user: userForEvent, day, hour, group });
  };

  return (
    <Flex1 onClick={onClick}>
      <AddEventBox isHovered={isHovered} fullWidth={!event} />
    </Flex1>
  );
};

export default ShowPlus;
